import { isSelfHostedDistribution } from "utils/distribution";

import useSelfHostedFlags from "./useSelfHostedFlags";
import useTypedFlags from "./useTypedFlags";

const isSelfHosted = isSelfHostedDistribution();

/**
 * Whether the Blob Storage VCS provider is enabled for the current account.
 * SaaS reads the flag from LaunchDarkly, self-hosted from the backend evaluated flags.
 */
const useBlobStorageFlag = (): boolean => {
  const { vcsProviderBlobStorage } = useTypedFlags();
  const { vcsProviderBlobStorage: vcsProviderBlobStorageSelfHosted } = useSelfHostedFlags();

  return isSelfHosted ? vcsProviderBlobStorageSelfHosted : vcsProviderBlobStorage;
};

export default useBlobStorageFlag;
